import { type Action, action } from "easy-peasy";

import DEFAULT from "./default";

export type FavouriteModelValue = false | number[];

export type FavouriteModel = {
  value: FavouriteModelValue;
  set: Action<FavouriteModel, FavouriteModelValue>;
};

const model: FavouriteModel = {
  value: DEFAULT,
  set: action((state, payload) => {
    state.value = payload;
  }),
};

export default model;
